import { axiosInstance } from "../../../axios/axiosInstance";

const API_WALLET_INFO_URL = "wallet";
const API_GIFT_CARD_URL = "gift_card";
const API_GET_WALLET_INFO_MODULE_LIST_URL =
  API_WALLET_INFO_URL + "/wallet-transactions";
const API_GIVE_WALLET_POINTS_URL = API_WALLET_INFO_URL + "/give-points";
const API_GET_GIFT_CARD_MODULE_LIST_URL = API_GIFT_CARD_URL + "/list";
const API_PURCHASE_GIFT_CARD_URL = API_GIFT_CARD_URL + "/purchase";
const API_VALIDATE_GIFT_CARD_URL = "/payment/validate_giftcard";
const API_REDEEME_GIFT_CODE_URL = "/wallet/give-points";

const API_GIFT_CARD_TRANSACTIONS_MODULE_LIST_URL =
  API_GIFT_CARD_URL + "/transactions";

export const getWalletInfo = (dataToBeSent) => {
  return axiosInstance.get(`${API_GET_WALLET_INFO_MODULE_LIST_URL}?page=${dataToBeSent?.page || ""}&limit=${dataToBeSent?.limit || ""}&search=${dataToBeSent?.search || ""}`);
};

export const givePoints = (dataToBeSent) => {
  return axiosInstance.post(API_GIVE_WALLET_POINTS_URL, dataToBeSent);
};

export const getGiftCards = (dataToBeSent) => {
  return axiosInstance.get(API_GET_GIFT_CARD_MODULE_LIST_URL, dataToBeSent);
};

export const purchaseGiftCard = (dataToBeSent) => {
  return axiosInstance.post(API_PURCHASE_GIFT_CARD_URL, dataToBeSent);
};

export const validateGiftCode = (dataToBeSent) => {
  return axiosInstance.post(API_VALIDATE_GIFT_CARD_URL, dataToBeSent);
};

export const redeemeGiftCode = (dataToBeSent) => {
  return axiosInstance.post(API_REDEEME_GIFT_CODE_URL, dataToBeSent);
};

export const getGiftCardTransactionInfo = () => {
  return axiosInstance.get(API_GIFT_CARD_TRANSACTIONS_MODULE_LIST_URL);
};
